import React, { forwardRef } from 'react';
import type { RatingProps } from '@mui/material';
import { Rating as RatingMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_COLOR } from './Rating.api';

const Rating = forwardRef<HTMLElement, RatingProps>((props, ref) => (
  <RatingMUI
    {...omitUndefinedProps({
      ...props,
      size: props.size ?? 'medium',
      color: undefined,
      [CUSTOM_ATTRIBUTE_COLOR]: props.color ?? 'warning',
    })}
    ref={ref}
  />
));

Rating.displayName = 'Rating';

export default Rating;
